import React from 'react';
import { useState } from 'react';

import { Accordion, ConditionalLabel } from './accordion';

type Params = {
  accordionTitle: React.ReactNode;
  additionalInfo?: React.ReactNode;
  children: React.ReactNode;
  ariaLabel: ConditionalLabel;
};

export const AccordionContainer: React.FC<Params> = (params: Params) => {
  const [open, setOpen] = useState(false);

  const toggleAccordion = () => {
    setOpen(!open);
  };

  return <Accordion {...params} open={open} toggleAccordion={toggleAccordion} />;
};
